/* import __COLOCATED_TEMPLATE__ from './editor-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import type AppService from 'embercom/services/app-service';
import type ContentImportService from 'embercom/services/content-import-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type StandalonePlatform } from 'embercom/objects/standalone/constants';

export default class EditorEmptyState extends Component {
  @service declare contentImportService: ContentImportService;
  @service declare appService: AppService;

  @tracked showStandaloneSideDrawer = false;

  get contentReviewSummary() {
    return this.contentImportService.aiContentReviewSummary;
  }

  get hasApprovedSuggestions() {
    if (!this.contentReviewSummary) {
      return false;
    }
    return this.contentReviewSummary.approved > 0;
  }

  get shouldShowZendeskConnectScreen() {
    return (
      // TODO: SA Generic platform migration – These buttons should work for all platforms
      this.appService.app.hasStandalonePlatform('zendesk') &&
      this.appService.app.isStandaloneApp &&
      !this.appService.mainStandalonePlatform.historicalSyncingEnabled
    );
  }

  get shouldShowSalesforceConnectScreen() {
    return (
      // TODO: SA Generic platform migration – These buttons should work for all platforms
      this.appService.app.hasStandalonePlatform('salesforce') &&
      this.appService.app.isStandaloneApp &&
      !this.appService.mainStandalonePlatform.historicalSyncingEnabled
    );
  }

  get currentPlatform(): StandalonePlatform {
    return this.appService.mainStandalonePlatform.platformKey;
  }

  @action
  closeStandaloneSideDrawer() {
    this.showStandaloneSideDrawer = false;
  }

  @action
  openStandaloneSideDrawer() {
    this.showStandaloneSideDrawer = true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::EditorEmptyState': typeof EditorEmptyState;
  }
}
